<template>
	<span>
		<v-btn v-if="editable" small :color="settings.audio ? 'green' : btnColor" text icon class="mr-1" @click="toggle('audio')">
			<v-icon small>{{settings.audio ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
		</v-btn>
		<v-icon small class="mr-2" v-else>{{settings.audio ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
		<slot name="audioText"></slot>
		<v-btn v-if="editable" small :color="settings.video ? 'green' : btnColor" text icon class="mr-1" @click="toggle('video')">
			<v-icon small>{{settings.video ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
		</v-btn>
		<v-icon small class="mr-2" v-else>{{settings.video ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
		<slot name="videoText"></slot>
	</span>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex"
	export default {
		name: "AVSettings", 
		props: {
			editable: {type: Boolean, default: () => true },
			room: {},
			btnColor: {type: String, default: () => "black"},
			settings: {type: Object, default: () => { 
				return {
					audio: true, 
					video: true
				}
			}}, 
		},

		computed: {
			...Vuex.mapState({
				role: state => state.auth.view, 
				user: state => state.auth.user,
			})
		},
		methods: {
			toggle(what){
				var userId = this.user.uid;
				if( !this.editable ){
					return;
				}
				var data = {}
				if( this.settings[what] === true ){
					data[what] = false;
				}
				else{
					data[what] = true
				}
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${userId}`, 
					action: "update", 
					data: data 
				})
			},
		},
	}
// </script>" -->